import axios from '@/plugins/axios';

export const getCustomerShippingAddresses = async (
  customerCode,
  { salesOrganization, channel }
) => {
  const { data } = await axios.post('/destinyCustomer', {
    customer: customerCode,
    VKORG: salesOrganization,
    VTWEG: channel,
  });

  return data;
};

export const getCustomerInfo = async (customerCode) => {
  const { data } = await axios.get(`/customers/${customerCode}/info`);

  return data;
};
